// src/components/tableros/tabs/ColumnasTab.js - Actualizado
import React from 'react';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Paper,
  FormGroup,
  Divider
} from '@mui/material';

/**
 * Tab de configuración de columnas para los distintos tableros.
 *
 *  • Pista (track) – muestra todas las secciones.
 *  • Campo (horizontalField / verticalField)
 *      – Vista individual   (displayRows === 1):  oculta todo → mensaje.
 *      – Vista de lista (>1):                     muestra solo "Información principal".
 */
const ColumnasTab = ({
  // Props básicos (comunes)
  showLane,
  showNumber,
  // Props de campo
  showAttemptNumber,
  // Props de pista
  showLastLapTime,
  showLapsToGo,
  showLapsColumns,
  showReactionTime,
  showTimeDifference,
  // Handlers y configuración
  handleCheckboxChange,
  boardType,
  displayRows
}) => {
  const isFieldBoard =
    boardType === 'horizontalField' || boardType === 'verticalField';
  const isHorizontalField = boardType === 'horizontalField';
  const isVerticalField = boardType === 'verticalField';

  /* ──── Vista individual de campo: nada que configurar ──── */
  if (isFieldBoard && displayRows === 1) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              En la vista individual no hay columnas que configurar.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  /* ──── Contenido estándar (con secciones condicionales) ──── */
  return (
    <Grid container spacing={3}>
      {/* Información principal – SIEMPRE visible */}
      <Grid item xs={12} md={6}>
        <Paper variant="outlined" sx={{ p: 2, height: '100%', minHeight: 180 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Información Principal
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showLane}
                  onChange={handleCheckboxChange}
                  name="showLane"
                />
              }
              label="Mostrar Carril"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={showNumber}
                  onChange={handleCheckboxChange}
                  name="showNumber"
                />
              }
              label="Mostrar Número/Dorsal"
            />
            
            {/* Para campo horizontal, mostrar opción de números de intento */}
            {isHorizontalField && displayRows > 1 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showAttemptNumber}
                    onChange={handleCheckboxChange}
                    name="showAttemptNumber"
                  />
                }
                label="Mostrar Número de Intento"
              />
            )}
          </FormGroup>
        </Paper>
      </Grid>

      {/* Secciones adicionales SOLO para pista */}
      {!isFieldBoard && (
        <>
          {/* Información de tiempos */}
          <Grid item xs={12} md={6}>
            <Paper
              variant="outlined"
              sx={{ p: 2, height: '100%', minHeight: 180 }}
            >
              <Typography variant="subtitle1" gutterBottom fontWeight="medium">
                Información de Tiempos
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showLastLapTime}
                      onChange={handleCheckboxChange}
                      name="showLastLapTime"
                    />
                  }
                  label="Mostrar T. Última Vuelta"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showTimeDifference}
                      onChange={handleCheckboxChange}
                      name="showTimeDifference"
                    />
                  }
                  label="Mostrar Diferencia de Tiempos"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showReactionTime}
                      onChange={handleCheckboxChange}
                      name="showReactionTime"
                    />
                  }
                  label="Mostrar Tiempo de Reacción"
                />
              </FormGroup>
            </Paper>
          </Grid>

          {/* Información de vueltas */}
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom fontWeight="medium">
                Información de Vueltas
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <FormGroup>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showLapsToGo}
                          onChange={handleCheckboxChange}
                          name="showLapsToGo"
                        />
                      }
                      label="Mostrar Vueltas Faltantes"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showLapsColumns}
                          onChange={handleCheckboxChange}
                          name="showLapsColumns"
                        />
                      }
                      label="Mostrar Columnas de Vueltas"
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </Paper>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ColumnasTab;